import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, SidePanel } from 'design-system-web';
import { WorkOrderModuleCategoriesSettings } from 'lane-shared/domains/workOrder';
import { useAssignableMembers } from 'lane-shared/domains/workOrder/hooks/useAssignableMembers';
import { TeamCoverageEntry } from './coverageHoursTeamUtils';
import { ALL_ISSUE_TYPES_VALUE } from './coverageHoursPanelUtils';
import { CreateCoverageHours } from './CreateCoverageHours';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  channelId: string;
  categories: WorkOrderModuleCategoriesSettings[];
};

export function CreateCoverageHoursPanel({
  isOpen,
  onClose,
  channelId,
  categories,
}: Props) {
  const { t } = useTranslation();
  const [, , assignableTeams] = useAssignableMembers(channelId);
  const [categoryValue, setCategoryValue] = useState<string | null>(null);
  const [issueTypeValue, setIssueTypeValue] = useState<string>(
    ALL_ISSUE_TYPES_VALUE
  );
  const [savedTeams, setSavedTeams] = useState<TeamCoverageEntry[]>([]);

  const handleCategoryChange = (value: string) => {
    setCategoryValue(value);
    setIssueTypeValue(ALL_ISSUE_TYPES_VALUE);
  };

  const handleClose = () => {
    setCategoryValue(null);
    setIssueTypeValue(ALL_ISSUE_TYPES_VALUE);
    setSavedTeams([]);
    onClose();
  };

  return (
    <SidePanel
      id="create-coverage-hours-panel"
      isOpen={isOpen}
      onClose={handleClose}
      header={t(
        'web.admin.serviceRequest.settings.coverageHours.create.title'
      )}
      size="medium"
      backdropEnabled
      footerActions={
        <>
          <Button variant="primary" size="large" disabled>
            {t(
              'web.admin.serviceRequest.settings.coverageHours.create.save'
            )}
          </Button>
          <Button variant="secondary" size="large" onClick={handleClose}>
            {t(
              'web.admin.serviceRequest.settings.coverageHours.create.cancel'
            )}
          </Button>
        </>
      }
    >
      <CreateCoverageHours
        categories={categories}
        categoryValue={categoryValue}
        onCategoryChange={handleCategoryChange}
        issueTypeValue={issueTypeValue}
        onIssueTypeChange={setIssueTypeValue}
        assignableTeams={assignableTeams}
        savedTeams={savedTeams}
        onAddTeam={entry => setSavedTeams(prev => [...prev, entry])}
      />
    </SidePanel>
  );
}
